module.exports = __webpack_public_path__ + "img/grid-1x2-fill.1fe5113f.svg";